import { render, staticRenderFns } from "./addInspectItem.vue?vue&type=template&id=cb851836&scoped=true&"
import script from "./addInspectItem.vue?vue&type=script&lang=js&"
export * from "./addInspectItem.vue?vue&type=script&lang=js&"
import style0 from "./addInspectItem.vue?vue&type=style&index=0&id=cb851836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb851836",
  null
  
)

export default component.exports